import React, { FC } from 'react';

import MuiIcon from '../../../MuiIcon';

import { SelectedItem } from '../types';

import * as Styled from './styled';

export type SelectedChipProps = {
  item: SelectedItem;
};

/**
 * Chip representing selected item
 *
 * @param props                     Props passed to the component
 * @param props.item                Selected item
 * @param props.item.label          Label for chip
 * @param props.item.onDelete       Callback to invoke when an item is removed
 * @param props.item.shouldShowIcon Whether to show icon or not
 *
 * @returns                         The component itself
 */
const SelectedChip: FC<SelectedChipProps> = ({
  item: { label, onDelete, shouldShowIcon },
}) => {
  const icon = shouldShowIcon ? (
    <MuiIcon fontSize="tiny" icon="users" />
  ) : undefined;

  return (
    <Styled.StyledListItem>
      <Styled.StyledChip
        deleteIcon={<MuiIcon fontSize="tiny" icon="close" />}
        icon={icon}
        label={label}
        onDelete={onDelete}
      />
    </Styled.StyledListItem>
  );
};

export default SelectedChip;
